import styled, { css } from 'styled-components';
import { media } from 'components/styles';

// Import styles
import { customMinResponsive } from 'components/styles';

const GradientBg = styled.div`
	position: absolute;
	inset: 0;
	width: 100%;
	aspect-ratio: 16 / 9;
	${media.min.min(css`
		height: 100%;
		aspect-ratio: unset;
	`)}
	overflow: hidden;

	${({ isPacket }) =>
		!isPacket &&
		css`
			z-index: 2;
		`}

	&:before,
	&:after {
		display: block;
		content: '';
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
	}

	&:before {
		background: linear-gradient(
			45deg,
			${({ theme, color }) => color ?? theme.black} 20%,
			transparent 80%,
			transparent 100%
		);

		${customMinResponsive(
			1271,
			css`
				background: linear-gradient(
					45deg,
					${({ theme, color }) => color ?? theme.black} 20%,
					transparent 60%,
					transparent 100%
				);
			`
		)}
	}

	&:after {
		background: linear-gradient(
			1deg,
			${({ theme, color }) => color ?? theme.black} 0%,
			${({ theme, color }) => color ?? theme.black} 7%,
			transparent 15%,
			transparent 100%
		);
	}
	${media.max.min(css`
		&:after {
			background: linear-gradient(
				1deg,
				${({ theme, color }) => color ?? theme.black} 0%,
				${({ theme, color }) => color ?? theme.black} 5%,
				transparent 65%,
				transparent 100%
			);
		}
		&:before {
			display: none;
		}
	`)}
`;

export default GradientBg;
